import React from "react";
import cedar_home_logo from "../../../assets/favicons/official-cedar-logo.png";
import nissan_logo from "../../../assets/favicons/nissan.png";
import { DarkLightToggle } from "../../Forms/common";

export const CedarShellHeader = () => {
  return (
    <header className="cedar_shell_header" data-test-id="cedar-shell-header">
      <div className="cedar_shell_header_logos">
        {/* Fixed to the expanded sidenav's own width so the divider after it lines up with where
            the sidenav ends, regardless of the Nissan logo's own natural width - see
            .cedar_shell_header_nissan_logo_area in cedarShell.scss for why this doesn't also
            track the sidenav's collapsed width. */}
        <div className="cedar_shell_header_nissan_logo_area">
          <img className="cedar_shell_header_nissan_logo" src={nissan_logo} alt="Nissan" />
        </div>
        <span className="cedar_shell_header_logo_divider" />
        {/* Logo and wordmark are grouped so they sit at their own tighter gap rather than the
            wider one separating the Nissan mark, divider, and this lockup. */}
        <div className="cedar_shell_header_cedar_lockup">
          {/* Decorative: the adjacent wordmark already carries the name, so a filled alt here
              would just make screen readers announce it twice. */}
          <img className="cedar_shell_header_cedar_logo" src={cedar_home_logo} alt="" />
          <h1 className="cedar_shell_header_cedar_wordmark">CEDAR</h1>
        </div>
      </div>
      <div className="cedar_shell_header_theme_toggle">
        <DarkLightToggle />
      </div>
    </header>
  );
};
